/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

export function getXHRPath(path: string): string {

  const hostnameMap = {
    'a.toyou.io': 'toyou.delivery',
    'd.toyou.io': 'demo.toyou.delivery',
    's.toyou.io': 'sand.toyou.delivery',
    'r.s.toyou.io': 'regres.toyou.delivery'
  };

  return location.hostname in hostnameMap
    ? `https://${hostnameMap[location.hostname]}${path}`
    : `https://sand.toyou.delivery${path}`;
}



// WEBPACK FOOTER //
// ./src/app/xhr-route.ts